import { DatePipe } from "@angular/common";
import { componentFactoryName } from "@angular/compiler";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseDefaultListFilterComponent, OrgJedView, CryptoService } from "yt-ng-framework";
import { EkranskaKarticaKomitenata } from "../_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata";
import { Router } from "@angular/router";

@Component({
    selector: 'filter-with-org-jed',
    templateUrl: './filter-with-org-jed.component.html'
})
export class FilterWithOrgJedComponent extends BaseDefaultListFilterComponent implements OnInit{

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }


    selectedOrgJed: string = 'Svi';
    orgJedIds: string = '';

    ngOnInit(){
        this.SetInitParameters();
    }

    SelectOrgJed(item: OrgJedView){
        this.selectedOrgJed = item != null ? item.Naziv : 'Svi';
    }


    SetInitParameters(){
        super.SetInitParameters();
        let date = new Date();
        this.filterFormGroup = new FormGroup({
            DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required]),
            OrgJedIDS: new FormControl('')
        })
    }

    SetFilterDescription(){
        super.SetFilterDescription();
        this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                                 ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') +
                                 ', Izabrane organizacione jedinice ';
    }

    //ako postoji samo jedna organizaciona jedinica onda da na MultiSelectu bude čekirana ta jedna org.jed.
    SkupiOrgJed(items){
        if (items && items.length == 1)
         {
            this.filterFormGroup.patchValue({OrgJedIDS : items[0].ID});
            this.filterFormGroup.get('OrgJedIDS').updateValueAndValidity();
            this.cryptedOrgJedIds = CryptoService.Encrypt(this.filterFormGroup.get('OrgJedIDS').value);
            sessionStorage.setItem('OrgJedIDs', this.cryptedOrgJedIds)
        }

        else if (items && items.length > 1)
        {
            
            items.forEach(item => this.orgJedIds += item.ID + ",");
            this.filterFormGroup.patchValue({OrgJedIDS : this.orgJedIds.substring(0, this.orgJedIds.length - 1)});
            //this.filterFormGroup.get('OrgJedIDS').updateValueAndValidity();
            //console.log(this.orgJedIds);
        }
    };

    cryptedOrgJedIds = "";
    ApplyFilter(): void {
        super.ApplyFilter();
      let cryptedKarticaKomitentaDatumOd = CryptoService.Encrypt(this.filterFormGroup.get('DateFrom').value);
      let cryptedKarticaKomitentaDatumDo = CryptoService.Encrypt(this.filterFormGroup.get('DateTo').value);
    //   let cryptedOrgJedIds = CryptoService.Encrypt(this.filterFormGroup.get('OrgJedIDS').value);
      this.cryptedOrgJedIds = CryptoService.Encrypt(this.filterFormGroup.get('OrgJedIDS').value);
      sessionStorage.setItem('KarticaKomitentaDatumOd', cryptedKarticaKomitentaDatumOd);
      sessionStorage.setItem('KarticaKomitentaDatumDo', cryptedKarticaKomitentaDatumDo);
      sessionStorage.setItem('OrgJedIDs', this.cryptedOrgJedIds)
    }


}
